import { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '@/lib/api';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { toast } from 'sonner';
import { Car, Mail } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [debugToken, setDebugToken] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await authAPI.forgotPassword({ email });
      toast.success(data.message);
      if (data.debug_token) setDebugToken(data.debug_token);
    } catch (err) {
      toast.error('Fehler beim Zurücksetzen');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 px-4" data-testid="forgot-password-page">
      <Card className="w-full max-w-md shadow-lg border-0 rounded-sm">
        <CardHeader className="text-center pb-2">
          <div className="flex justify-center mb-4">
            <div className="w-12 h-12 bg-[#0E518D] rounded-sm flex items-center justify-center">
              <Car className="w-6 h-6 text-white" strokeWidth={1.5} />
            </div>
          </div>
          <CardTitle className="font-heading text-2xl text-slate-900">Passwort vergessen</CardTitle>
          <p className="text-sm text-slate-500 font-body mt-1">Geben Sie Ihre E-Mail-Adresse ein</p>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit} className="space-y-4">
            <div>
              <Label htmlFor="email" className="font-body text-sm">E-Mail</Label>
              <Input
                id="email"
                data-testid="forgot-email-input"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="admin@gb-sylt.de"
                className="mt-1 rounded-sm"
                required
              />
            </div>
            <Button
              type="submit"
              data-testid="forgot-submit-button"
              className="w-full bg-[#0E518D] hover:bg-[#0B4171] text-white rounded-sm py-3 font-body"
              disabled={loading}
            >
              <Mail className="w-4 h-4 mr-2" /> Reset-Link anfordern
            </Button>
          </form>
          {debugToken && (
            <div className="mt-4 p-3 bg-amber-50 border border-amber-200 rounded-sm" data-testid="debug-token-display">
              <p className="text-xs text-amber-700 font-body font-semibold mb-1">MVP Debug Token:</p>
              <p className="text-xs text-amber-800 font-mono break-all">{debugToken}</p>
              <Link
                to={`/admin/reset-password?token=${debugToken}`}
                className="text-xs text-[#0E518D] underline font-body mt-2 block"
              >
                Passwort jetzt zurücksetzen
              </Link>
            </div>
          )}
          <div className="mt-4 text-center">
            <Link to="/admin/login" className="text-sm text-[#0E518D] hover:underline font-body">
              Zurück zum Login
            </Link>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
